import { useState } from "react";
import { S3Tags } from "./types";

type VideoDebugProps = {
  title: string;
  tags: S3Tags[];
  dates?: string[];
  thumbnails: string[];
};

function VideoDebugInfo({ title, tags, dates, thumbnails }: VideoDebugProps) {
  const [isDebugOpen, setIsDebugOpen] = useState(false);

  return (
    <div className="mt-3">
      <button
        onClick={() => setIsDebugOpen(!isDebugOpen)}
        className="flex w-full rounded bg-base-200 items-center gap-1 text-xs text-base-content/50 transition-all px-1"
      >
        <svg
          className={`w-3 h-3 transition-transform ${isDebugOpen ? "rotate-90" : ""}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clipRule="evenodd"
          />
        </svg>
        Debug Info
      </button>

      {isDebugOpen && (
        <div className="mt-2 p-3 bg-base-200 rounded-lg text-xs font-mono space-y-1">
          <div className="grid grid-cols-1 gap-1">
            <div>
              <span className="text-base-content/50">Title:</span>
              <span className="ml-2 text-base-content/80 break-all">
                {title}
              </span>
            </div>
            <div>
              <span className="text-base-content/50">Thumbnails:</span>
              <span className="ml-2 text-base-content/80">
                {thumbnails.length} loaded
              </span>
            </div>
            {dates && dates.length > 0 && (
              <div>
                <span className="text-base-content/50">Dates:</span>
                <span className="ml-2 text-base-content/80">
                  {dates.join(", ")}
                </span>
              </div>
            )}
            {tags && tags.length > 0 && (
              <div>
                <span className="text-base-content/50">Tags:</span>
                <div className="ml-2 text-base-content/80 text-wrap break-all">
                  {tags.map((tag, idx) => (
                    <div key={idx}>
                      {tag.Key}: {tag.Value}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default VideoDebugInfo;
